// extracted by mini-css-extract-plugin
export default {"project-chat":"ProjectChat_project-chat__n5TC4","project-chat__list":"ProjectChat_project-chat__list__f6UWS","project-chat__commentbox":"ProjectChat_project-chat__commentbox__3VFpP"};